import type { ThemeDefinition } from './types';

export const highContrast: ThemeDefinition = {
  id: 'high-contrast',
  name: 'High Contrast',
  description: 'WCAG AAA compliant — maximum contrast with bold borders for accessibility',
  mode: 'light',
  tokens: {
    colorPrimary: '#0000CC',
    colorSecondary: '#CC6600',
    colorAccent: '#FFD700',
    colorSuccess: '#006600',
    colorWarning: '#CC6600',
    colorError: '#CC0000',
    colorInfo: '#0000CC',
    colorBgBase: '#FFFFFF',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    colorBgSidebar: '#000000',
    colorText: '#000000',
    colorTextSecondary: '#1A1A1A',
    colorTextTertiary: '#333333',
    colorBorder: '#000000',
    colorBorderSecondary: '#333333',
    boxShadow: '0 0 0 2px #000000',
    boxShadowSecondary: '0 0 0 3px #000000',
    glassBlur: '0px',
    glassOpacity: '1',
    glassSaturation: '100%',
    fontFamily: '"Arial", "Helvetica Neue", Helvetica, sans-serif',
    fontFamilyHeading: '"Arial Black", "Arial Bold", Arial, sans-serif',
    fontSize: 16,
    fontSizeHeading: 22,
    borderRadius: 4,
    borderRadiusLG: 8,
    cardBorder: '#000000',
    cardShadow: '0 0 0 2px #000000',
  },
  antdOverrides: {
    wireframe: true,
  },
};
